import * as React from 'react'
import Data from 'EurestoClass/Data'

import { Grid, Menu, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import Input from './Input'
import DataComponent from 'EurestoComponents/DataComponent'
import moment from 'moment'
import 'moment/locale/fr'
import AutoComplete from './AutoComplete'
import DatePicker from './DatePicker'
import ReactDOMServer from 'react-dom/server'
import ReactExport from 'react-data-export'

import h2p from 'html2plaintext'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import EurestoInfinityScroll from 'Components/EurestoInfinityScroll'
import Bus from 'EurestoClass/Bus'

const { ExcelFile } = ReactExport
const { ExcelSheet } = ExcelFile

moment.locale('fr')

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#E4E4E4',
    height: '100%'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableColHeader: {
    width: `25%`,
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5
  },
  tableCol: {
    width: `25%`,
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5
  },
  tableCellHeader: {
    margin: 'auto',
    fontSize: 12,
    fontWeight: 500
  },
  tableCell: {
    margin: 'auto',
    fontSize:
      10
  }
})

class EurestoTable extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      columns: props.columns.filter(el => el.show !== false),
      datas: props.datas || [],
      selectedRowIndex: props.selectedRowIndex,
      openMenu: [],
      headerSort: {},
      filters: [],
      compareValues: [],
      listValues: [],
      addressesSearch: [],
      searches: [],
      addressCode: 0,
      addressVille: '',
      rightClickMenu: false,
      datePickers: props.columns.filter(el => el.type === 'date' && el.show !== false).map(el => {
        return { id: el.id, date: null, range: el.range }
      }),
      renderPDF: 0,
      key: Utils.getRandomNumber()
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const datas = EurestoClone((this.state.datas || []))
    console.log()
    console.log('##########"', (nextProps.selectedRowIndex !== this.state.selectedRowIndex && { selectedRowIndex: nextProps.selectedRowIndex } || {}))
    this.setState({
      ...(nextProps.datas !== datas && { datas: nextProps.datas } || {}),
      ...(nextProps.selectedRowIndex !== this.state.selectedRowIndex && { selectedRowIndex: nextProps.selectedRowIndex } || {})
    })
  }

  /* PDF related */

  //Génère le document pdf à partir des données de la table filtrée/triée
  myDocument = () => (
    <Document>
      <Page size="A4" style={styles.body}>
        <Text style={{ margin: 20, fontSize: 30 }}>{this.props.title || 'Votre Tableau'}</Text>
        {/* Ajouter entete du restaurant ici */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            {
              Object.keys((this.state.datas || [])[0]).map((el, i) => {
                return <View key={i} style={styles.tableColHeader}>
                  <Text style={styles.tableCellHeader}>{h2p(ReactDOMServer.renderToString(el))}</Text>
                </View>
              })
            }
          </View>
          {(this.state.datas || []).map((el, j) =>
            <View key={j} style={styles.tableRow}>
              {Object.values(el).map((val, i) => {
                if (typeof (val) === 'object') {
                  return <View key={i} style={styles.tableCol}>
                    <Text
                      style={Object.assign({}, styles.tableCell, (val && val.props && val.props.style || {}))}>{h2p(ReactDOMServer.renderToString(val))}</Text>
                  </View>
                } else {
                  return <View key={i} style={styles.tableCol}>
                    <Text style={styles.tableCell}>{val}</Text>
                  </View>
                }
              })
              }
            </View>)}
        </View>
      </Page>
    </Document>
  )

  //Affiche la preview du pdf
  renderPDF = () => {
    let width = (Math.floor(100 / (Object.keys((this.state.datas || [])[0]).length)) || '100') + '%'
    styles.tableColHeader.width = width
    styles.tableCol.width = width
    let doc = this.myDocument()
    this.setState({ renderPDF: 1, pdf: doc })
  }

  //Génère une table XLSX à partir des données de la table affichées/triées
  tableToXLSX = () => {
    return ([{
      columns: this.state.columns.map(el => el.id),
      datas: (this.state.datas || []).map(el => {
        let values = Object.values(el)
        values = values.map(elem => {
          if (typeof (elem) === 'object') {
            return h2p(ReactDOMServer.renderToString(elem))
          } else {
            return elem
          }
        })
        return values
      })
    }])
  }

  //Ferme le menu après action
  downloadPDF = () => {
    this.setState({ rightClickMenu: null })
  }

  downloadXLS = () => {
    this.setState({ rightClickMenu: null })
  }

  closePDF = () => {
    this.setState({ renderPDF: 0 })
  }

  /* Sort */

  //Trie la table au clic sur un header
  onheaderClick = (header, type, order) => {
    let header_sort = this.state.headerSort
    let new_data
    let column = this.state.columns.find(el => el.id === header)
    let filterFunc = column.filters && column.filters.find(filter => typeof (filter) === 'function')
    this.props.search && Bus.$emit('sorted_search_' + this.props.search, [{ id: header, desc: !(order !== undefined ? order : !header_sort.ascended) }])
    if (filterFunc) {
      new_data = ((this.state.datas || []).sort(filterFunc))
    } else {
      if (header_sort.id === header) {
        header_sort.ascended = order !== undefined ? order : !header_sort.ascended
        if (type === 'number') {
          if (header_sort.ascended) {
            new_data = ((this.state.datas || []).sort((a, b) => b[header] - a[header]))
          } else {
            new_data = ((this.state.datas || []).sort((a, b) => a[header] - b[header]))
          }
        } else if (type === 'string') {
          if (column.info_tiers) {
            if (header_sort.ascended) {
              new_data = ((this.state.datas || []).sort((a, b) =>
                ((Data.get(column.info_tiers.module, column.info_tiers.donnee, { [column.info_tiers.champ || 'id']: b[header] }) || {})[column.info_tiers.row || 'libelle'] || '').insensitiveCaseAccents()
                  > ((Data.get(column.info_tiers.module, column.info_tiers.donnee, { [column.info_tiers.champ || 'id']: a[header] }) || {})[column.info_tiers.row || 'libelle'] || '').insensitiveCaseAccents() ? 1 : -1))
            } else {
              new_data = ((this.state.datas || []).sort((a, b) =>
                ((Data.get(column.info_tiers.module, column.info_tiers.donnee, { [column.info_tiers.champ || 'id']: b[header] }) || {})[column.info_tiers.row || 'libelle'] || '').insensitiveCaseAccents()
                  < ((Data.get(column.info_tiers.module, column.info_tiers.donnee, { [column.info_tiers.champ || 'id']: a[header] }) || {})[column.info_tiers.row || 'libelle'] || '').insensitiveCaseAccents() ? 1 : -1))
            }
          } else {
            if (header_sort.ascended) {
              new_data = ((this.state.datas || []).sort((a, b) => (b[header] + '').insensitiveCaseAccents() > (a[header] + '').insensitiveCaseAccents() ? 1 : -1))
            } else {
              new_data = ((this.state.datas || []).sort((a, b) => (b[header] + '').insensitiveCaseAccents() < (a[header] + '').insensitiveCaseAccents() ? 1 : -1))
            }
          }
        } else if (type === 'date') {
          if (header_sort.ascended) {
            new_data = (this.state.datas || []).sort((a, b) => moment(a[header]).isBefore(moment(b[header])) ? 1 : -1)
          } else {
            new_data = (this.state.datas || []).sort((a, b) => moment(a[header]).isAfter(moment(b[header])) ? 1 : -1)
          }
        }
      } else {
        header_sort.id = header
        header_sort.ascended = order !== undefined ? order : !header_sort.ascended
        if (type === 'number') {
          new_data = ((this.state.datas || []).sort((a, b) => b[header] - a[header]))
        } else if (type === 'string') {
          new_data = ((this.state.datas || []).sort((a, b) => b[header] > a[header] ? 1 : -1))
        } else if (type === 'date') {
          new_data = (this.state.datas || []).sort((a, b) => {
            return moment((a[header])).isBefore(moment((b[header]))) ? 1 : -1
          })
        }
      }
    }
    this.setState({ headerSort: header_sort, datas: new_data })
  }

  /* misc & UI */

  operate = (string, a, b) => {
    a = parseInt(a)
    b = parseInt(b)
    if (string === '>') return (a > b)
    if (string === '<') return (a < b)
    if (string === '>=') return (a >= b)
    if (string === '<=') return (a <= b)
    if (string === '=') return (a === b)
    if (string === '!=') return (a !== b)
  }

  //ouvre le menu des filtres
  openMenu = (header) => {
    let op_men = this.state.openMenu
    op_men[header] = true
    this.setState({ openMenu: op_men })
  }

  closeMenu = (header) => {
    let op_men = this.state.openMenu
    op_men[header] = false
    this.setState({ openMenu: op_men })
  }

  //filtre la table à partir lorsque un nouveau filtre est ajouté avec celui ci et les filtres existants
  filterArray = (newFilter) => {
    let tab = this.state.filters
    let rows = this.props.datas || []
    //modify header val if exist
    if (typeof (newFilter) === 'string') {
      tab = tab.filter(el => el.id !== newFilter)
    } else {
      let filt = tab.find(el => newFilter.id === el.id)
      if (filt) {
        tab[tab.indexOf(filt)].value = newFilter.value
        if (tab[tab.indexOf(filt)].operator !== newFilter.operator) tab[tab.indexOf(filt)].operator = newFilter.operator
      } else {
        tab.push(newFilter)
      }
    }
    let filtered = rows.filter(row => {
      let result = tab.map(filter => {
        const row_filter_header = row[filter.id]
        if (filter.operator === ('str_equal')) {
          if (row_filter_header === filter.value) {
            return row
          } else {
            return -1
          }
        } else if (filter.operator === ('str_includes')) {
          if (((row_filter_header + '') || '').insensitiveCaseAccents().includes(((filter.value + '') || '').insensitiveCaseAccents())) {
            return row
          } else {
            return -1
          }
        } else if (filter.operator === ('int_compare')) {
          if (this.operate(filter.math_operator || '=', row_filter_header, filter.value)) {
            return row
          } else {
            return -1
          }
        } else if (filter.operator === ('date_equal')) {
          if (moment(row_filter_header).isSame(moment(filter.value), 'day')) {
            return row
          } else {
            return -1
          }
        } else if (filter.operator === ('date_between')) {
          if (moment(row_filter_header).isSameOrBefore(moment(filter.value[1]), 'day') && moment(row[filter.header]).isSameOrAfter(moment(filter.value[0]), 'day')) {
            return row
          } else {
            return -1
          }
        }
      })
      if (!newFilter.value || !result.includes(-1)) {
        return true
      } else {
        return false
      }
    })
    return { datas: filtered, filters: tab }
  }

  /* Filters */
  //filtre de recherche dans un textfield
  handleSearchField = (value, header) => {
    let filters = this.state.filters
    let filter_head = filters.find(el => el.id === header)
    let searches = this.state.searches
    if (value && (value + '').length === 0) {
      let filtered = this.filterArray(header)
      searches = searches.find(el => el.id !== header) || []
      this.setState({ datas: filtered.datas, filters: filtered.filters, searches: searches })
    } else {
      if (filter_head) {
        if (filter_head.operator === 'str_equal') filter_head.operator = 'str_includes'
        filter_head.value = value
        if (searches.find(el => el.id === header)) {
          searches[searches.indexOf(searches.find(el => el.id === header))].value = value
        } else {
          searches.push({ id: header, value: value })
        }
      } else {
        filter_head = { id: header, operator: 'str_includes', value: value }
        searches.push({ id: header, value: value })
      }
      let filtered = this.filterArray(filter_head)
      this.setState({
        datas: filtered.datas,
        filters: filtered.filters.filter(f => f.value !== undefined),
        searches: searches.filter(f => f.value !== undefined)
      })
    }
  }

  //filtre de comparaison entre 2 nombres
  handleCompareChange = (e, header) => {
    let filters = this.state.filters
    let values = this.state.compareValues
    let filt = filters.find(el => el.id === header)
    let new_filter
    if (e.target.value.length === 0) {
      // data - , filters -, tab spec - => header
      let filtered = this.filterArray(header)
      values.find(el => el.id === header).value = ''
      this.setState({ datas: filtered.datas, filters: filtered.filters, compareValues: values })
    } else {
      if (filt) {
        new_filter = filt
        new_filter.value = e.target.value
        if (values.find(el => el.id === header)) values.find(el => el.id === header).value = e.target.value
      } else {
        new_filter = {
          id: header,
          value: e.target.value,
          operator: 'int_compare',
          math_operator: (values.find(el => el.id === header) || {}).operator || '='
        }
        if (values.find(el => el.id === header)) {
          values.find(el => el.id === header).value = e.target.value
        } else {
          values.push({
            id: header,
            operator: (values.find(el => el.id === header) || {}).operator || '=',
            value: e.target.value
          })
        }
      }
      let filtered = this.filterArray(new_filter)
      this.setState({ datas: filtered.datas, filters: filtered.filters, compareValues: values })
    }
  }

  //implemeter plus tard
  changeCompareOperator = (e, header) => {
    let rows = this.props.datas || []
    let operator = (this.state.compareValues.find(el => el.id === header) || '')
    let new_operator = this.state.compareValues
    if (!operator) {
      new_operator.push({ id: header, operator: e.target.value })
    } else {
      new_operator[new_operator.indexOf(operator)].operator = e.target.value
      let searched = rows.filter(el => this.operate(new_operator.find(el => el.id === header).operator, el[header], operator.value))
      this.setState({ datas: searched })
    }
    this.setState({ compareValues: new_operator })
  }

  //Affiche les actions possibles sur la table
  onRightClickTable = (e) => {
    this.setState({ rightClickMenu: { x: e.clientX, y: e.clientY } })
    e.preventDefault()
  }

  onClickAwayRightMenu = () => {
    this.setState({ rightClickMenu: null })
  }

  //filtre de selection de la date(jour ou plage de jour)
  onDateChange = (dates, name) => {
    let datepickers = this.state.datePickers
    let elem = datepickers.find(el => el.id === name)
    let filtered
    let new_filter
    if (elem) {
      elem.date = dates
      if (!elem.date) {
        filtered = this.filterArray(name)
      } else if (!elem.range) {
        new_filter = { id: name, value: elem.date, operator: 'date_equal' }
        filtered = this.filterArray(new_filter)
      } else {
        new_filter = { id: name, value: elem.date, operator: 'date_between' }
        filtered = this.filterArray(new_filter)
      }
      this.setState({ datePickers: datepickers, datas: filtered.datas, filters: filtered.filters })
    }
  }

  handleElemClick = (index) => {
    console.log(index)
    this.setState({ selectedRowIndex: index })
  }

  render() {
    return (
      <Grid container spacing={0}
        style={this.props.maxHeight ? { maxHeight: this.props.maxHeight, overflow: 'auto' } : {}}>
        <Table id={'euresto-table-' + this.state.key} stickyHeader aria-label="sticky table">
          {!this.props.hideHeader && <TableHead>
            <TableRow>
              {this.state.columns.map((column, i) => {
                return <TableCell style={{ width: column.width || 'auto', minWidth: column.minWidth || 'auto', maxWidth: column.maxWidth || 'auto' }} key={column.id} className={column.headerClassName}>
                  <Grid container direction={'row'} justify={'flex-start'} alignItems={'center'} alignContent={'center'}
                    wrap={'nowrap'} style={{ height: '100%' }}>
                    {column.sortable !== false &&
                      <Grid item style={{ paddingRight: 5 }}>
                        <Grid container direction={'column'}>
                          <i className={'ei-commun_chevron_up'}
                            onClick={() => this.onheaderClick(column.id, column.type, true)}
                            style={{
                              cursor: 'pointer',
                              fontSize: 7.14,
                              color: `${((this.state.headerSort.id === column.id && this.state.headerSort.ascended === true) && '#007BFF') || '#7d7d7d'}`
                            }} />
                          <i className={'ei-commun_chevron_down'}
                            onClick={() => this.onheaderClick(column.id, column.type, false)}
                            style={{
                              cursor: 'pointer',
                              fontSize: 7.14,
                              color: `${((this.state.headerSort.id === column.id && this.state.headerSort.ascended === false) && '#007BFF') || '#7d7d7d'}`
                            }} />
                        </Grid>
                      </Grid>}
                    <Grid item xs style={{ height: '100%' }}
                      onClick={() => column.sortable !== false ? this.onheaderClick(column.id, column.type) : null}>
                      {column.header}
                    </Grid>
                    {this.props.filterable !== false && column.filters && column.filters.length > 0 &&
                      <Grid item style={{ paddingRight: 5 }}>
                        <Grid container direction={'row'} justify={'flex-end'}
                          alignItems={'flex-start'}>
                          <Grid item>
                            {(this.state.filters.filter(filt => filt.id === column.id).length > 0) &&
                              <i className={'ei-commun_fermer'} id={column.id}
                                onClick={() => this.handleSearchField(undefined, column.id)} style={{
                                  cursor: 'pointer',
                                  color: EurestoColor('EurestoError')
                                }} />}
                            <i className={'ei-commun_filtrer'} id={column.id}
                              onClick={() => this.openMenu(column.id)} style={{
                                cursor: 'pointer',
                                color: `${(this.state.filters.filter(filt => filt.id === column.id).length > 0) ? EurestoColor('EurestoSecondary') : 'inherit'}`
                              }} />
                            <Menu
                              open={this.state.openMenu[column.id] || false}
                              anchorEl={document.getElementById(column.id) || null}
                              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                              PaperProps={{ style: { marginTop: 15, overflow: 'visible' } }}
                              onClose={() => this.closeMenu(column.id)}>
                              {column.filters.includes('search') &&
                                (column.info_tiers &&
                                  <DataComponent
                                    className={'searchFicolumnd'}
                                    name={column.id}
                                    fullWidth
                                    inputStyle={{ marginBottom: 0 }}
                                    type={column.info_tiers.type_saisie || Constants.typeSaisie.ComboSimple}
                                    onChange={(data, name) => {
                                      this.handleSearchField(data, name)
                                      this.closeMenu(column.id)
                                    }}
                                    search={{ [column.info_tiers.champ || 'id']: { in: (this.props.datas || []).map(el => el[column.id]) } }}
                                    data={(this.state.searches.find(columnem => columnem.id === column.id) || {}).value || ''}
                                    object={column.info_tiers.donnee}
                                    module={column.info_tiers.module} /> ||
                                  <AutoComplete className={'searchFicolumnd'} variant={'outlined'}
                                    name={column.id}
                                    fullWidth
                                    onChangeText={this.handleSearchField}
                                    onChange={() => this.closeMenu(column.id)}
                                    title={column.header}
                                    inputStyle={{ marginBottom: 0 }}
                                    data={(this.state.searches.find(columnem => columnem.id === column.id) || {}).value || ''}
                                    options={Array.from(new Set((this.props.datas || []).map(el => el[column.id])))
                                      .map(elem => ({
                                        label: elem,
                                        value: elem
                                      }))} />)}
                              {column.filters.includes('compare') &&
                                <Input className={'numberSearchField'}
                                  variant={'outlined'}
                                  fullWidth
                                  style={{ marginBottom: 0 }}
                                  title={column.header}
                                  value={(this.state.compareValues.find(elem => elem.id === column.id) || '').value || ''}
                                  onChange={(e) => this.handleCompareChange(e, column.id)}
                                />}
                              {column.filters.includes('datepicker') &&
                                <DatePicker
                                  fullWidth
                                  name={column.id}
                                  onChange={this.onDateChange}
                                  range={((this.state.datePickers.find(elem => elem.id === column.id) || {}).range || false)}
                                  value={((this.state.datePickers.find(elem => elem.id === column.id) || {}).date) || null} //startdate
                                />
                              }
                            </Menu>
                          </Grid>
                        </Grid>
                      </Grid>}
                  </Grid>
                </TableCell>
              })}
            </TableRow>
          </TableHead>}
          <TableBody id={this.state.key + '-body'}>
            {
              (this.state.datas || []).map((row, i) => <TableRow key={'row' + i + (this.state.selectedRowIndex === i)}
                style={{ cursor: 'pointer', ...(this.props.styleRow && this.props.styleRow(row) || {}) }}
                selected={this.state.selectedRowIndex === i} hover>
                {
                  (this.state.columns || []).map((column, j) => <TableCell
                    key={column.id + i + j}
                    id={'cell' + i + j}
                    onContextMenu={(el) => {
                      el.preventDefault()
                      this.props.onContextMenu && this.props.onContextMenu(row, i)
                    }}
                    onClick={() => {
                      this.handleElemClick(i)
                      column.onClick ? column.onClick(row, i) : (this.props.onClick && this.props.onClick(row, i))
                    }}>{column.Cell ? column.Cell(row, i) : (column.type === 'date' && column.format && row[column.id] && moment(row[column.id]).format(column.format) || row[column.id] || '')}
                  </TableCell>)
                }
              </TableRow>)
            }
            {this.props.infinityScroll && <EurestoInfinityScroll
              {...this.props.infinityScroll}
              search={this.props.search}
              showLoader />}
          </TableBody>
        </Table>
      </Grid>
    )
  }
}

export default EurestoTable


// WEBPACK FOOTER //
// ./app/Components/EurestoTable.js